<template>
    <div v-if="text !== null">
        <h5 class="mb-3">Onde Comprar</h5>
        <div v-html="text"></div>
    </div>
</template>

<script>
    export default {
        name: "BuyEstar",
        data:function () {
            return{
                text:null
            }
        },
        mounted() {
            axios.get('/api/webdriver/landpage',{params:{tags:'onde_comprar'}}).then(res => {
                this.text = res.data.data[0].content;
                if(this.text !== null){
                    this.$emit('show',true);
                }
            })
        }
    }
</script>

<style scoped>
    .box{
        display: flex;

    }
    .b-1{
        width: 300px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .b-2{
        display: flex;
        align-items: center;
    }

    .b-2 > div{
        width: 100%;
        height: auto;
        padding-left: 100px;
    }


    h5{
        font-family: Roboto-Black;
        font-size: 24px;
        color: #58595B;
    }
</style>